import React, { useState } from "react";
import styled from "styled-components";
import { useStripe } from "@stripe/react-stripe-js";
import axios from "axios";

import { ReactComponent as StripeLogoSVG } from "../../img/stripe.svg";
import { Panel } from "../../components/Panel";
import { Box } from "../../components/Box";
import Button from "../../components/Button";
import { Text } from "../../components/Text";
import { Flex } from "../../components/Flex";
import { useSubscription } from "../../auth/Subscription";
import { Redirect } from "react-router";
import { FaLock } from "react-icons/fa";

const pricings = [
  {
    id: process.env.REACT_APP_STRIPE_MONTHLY_ID
  },
  {
    id: process.env.REACT_APP_STRIPE_YEARLY_ID
  },
  {
    id: process.env.REACT_APP_STRIPE_FOUNDERS_ID
  }
];

const PriceButton = styled.button`
  padding: ${(props) => props.theme.space[2]}px;
  background-color: ${(props) =>
    props.active ? props.theme.colors.primary : props.theme.colors.background};
  border: 1px solid ${(props) => props.theme.colors.grey2};
  color: ${(props) => (props.active ? "white" : props.theme.colors.body)};
  flex: 1;
  cursor: pointer;
`;

const StripeLogo = styled(StripeLogoSVG)`
  height: 26px;
  fill: ${(props) => props.theme.colors.body};
`;

export default function CheckoutForm() {
  const stripe = useStripe();
  const [subscription] = useSubscription();
  const [priceId, setPriceId] = useState(pricings[1].id);

  if (
    subscription != null &&
    subscription.type !== "free-trial" &&
    subscription.type !== "expired"
  ) {
    return <Redirect to="/settings/subscription" />;
  }

  const checkout = async () => {
    const { data: session } = await axios.post(
      "/api/subscriptions/create-checkout",
      {
        priceId
      }
    );

    const result = await stripe.redirectToCheckout({
      sessionId: session.id
    });

    if (result.error) {
      window.alert(result.error.message);
    }
  };

  return (
    <Box p={5} width="800px" ml="auto" mr="auto">
      <Flex mb={2}>
        <Panel flex={1} mr={2}>
          <Text fontSize={4} fontWeight={600} mb={2}>
            Professional
          </Text>
          <Flex>
            <PriceButton
              onClick={() => setPriceId(pricings[0].id)}
              active={priceId === pricings[0].id}
            >
              <Text fontSize={6} as="span">
                $4 <small>/ month</small>
              </Text>
              <Text as="small">${4 * 12} / year</Text>
            </PriceButton>
            <PriceButton
              onClick={() => setPriceId(pricings[1].id)}
              active={priceId === pricings[1].id}
            >
              <Text fontSize={6} as="span">
                $36 <small>/ year</small>
              </Text>
              <Text as="small">$3 / month</Text>
            </PriceButton>
          </Flex>
          <Box style={{ textAlign: "center" }} p={2}>
            <Text>
              <strong>What gets scheduled, gets done.</strong>
              <br />- Michael Hyatt
            </Text>
          </Box>
        </Panel>
        <Panel flex={1}>
          <Text fontSize={4} fontWeight={600} mb={2}>
            Founder's Edition
          </Text>
          <Flex>
            <PriceButton
              onClick={() => setPriceId(pricings[2].id)}
              active={priceId === pricings[2].id}
            >
              <Text fontSize={6} as="span">
                $149.99
              </Text>
              <Text as="small">Lifetime access</Text>
            </PriceButton>
          </Flex>
          <Box style={{ textAlign: "center" }} p={2}>
            <Text fontWeight={600}>
              You're serious about productivity!
              <br />
              Early access to new features.
              <br />
              Priority support.
            </Text>
          </Box>
        </Panel>
      </Flex>
      <Flex
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        p={3}
      >
        <Button onClick={checkout} large mb={2} icon={FaLock}>
          Checkout
        </Button>
        <StripeLogo />
      </Flex>
    </Box>
  );
}
